import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function AdminDashboard({ user }) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateUser, setShowCreateUser] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    role: 'backend_user'
  });

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_URL}/employees`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEmployees(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching employees:', err);
      setLoading(false);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_URL}/auth/create-backend-user`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      alert(`Backend user created!\nEmail: ${formData.email}\nTemporary Password: ${response.data.temporaryPassword}`);
      setFormData({ name: '', email: '', phone: '', role: 'backend_user' });
      setShowCreateUser(false);
      fetchEmployees();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to create user');
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>System Administration</h1>
        <p>Manage users and system settings</p>
      </div>

      <div className="section-card">
        <h2>Create Backend User / Admin</h2>
        <button className="btn btn-primary" onClick={() => setShowCreateUser(!showCreateUser)}>
          {showCreateUser ? 'Cancel' : 'Create New User'}
        </button>

        {showCreateUser && (
          <form onSubmit={handleCreateUser} style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
            <div className="form-row">
              <div className="form-group">
                <label>Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label>Phone *</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  required
                />
              </div>

              <div className="form-group">
                <label>Role *</label>
                <select
                  value={formData.role}
                  onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                >
                  <option value="backend_user">Backend User</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            </div>

            <button type="submit" className="btn btn-success">Create User</button>
          </form>
        )}
      </div>

      <div className="section-card">
        <h2>Employees ({employees.filter(e => !e.resignation_date).length})</h2>
        
        {employees.length === 0 ? (
          <p style={{ color: '#999' }}>No employees found.</p>
        ) : (
          <div className="table-responsive">
            <table>
              <thead>
                <tr>
                  <th>PAN ID</th>
                  <th>Name</th>
                  {/* <th>Email</th> */}
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {employees.map(emp => (
                  <tr key={emp.id} style={{ opacity: emp.resignation_date ? 0.6 : 1 }}>
                    <td>{emp.pan_id}</td>
                    <td>{emp.name}</td>
                    {/* <td>{emp.email}</td> */}
                    <td>{emp.phone}</td>  
                    <td>
                      {emp.resignation_date ? (
                        <span className="badge danger">Resigned</span>
                      ) : (
                        <span className="badge success">Active</span>
                      )}
                    </td>
                    <td>
                      <div className="btn-group" style={{ gap: '6px' }}>
                        <Link to={`/employees/${emp.id}/details`} className="btn btn-primary btn-sm link-btn">
                          Details
                        </Link>
                        <Link to={`/employees/${emp.id}/documents`} className="btn btn-secondary btn-sm link-btn">
                          Documents
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
